<template>
   <div class="inline">
     <div>
        <p v-if="offices.length < 4" class="text-xs">{{userAssociatedText}}</p>
        <p v-else class="text-blue text-xs" v-on:mouseover="hover(true)" v-on:mouseout="hoverOut">{{offices.length}} X Offices</p>
     </div>
     <div class="user-popover rounded-lg ml-6 p-3 px-4"  transition="fade" v-on:mouseover="hoverInfo" v-on:mouseout="hoverOutInfo" v-if="showPopup">
      <div class="flex flex-col h-32 scrollbar p-1">
        <div class="mb-2 border-b" v-for="(office,index) in offices" :key="index">
          <div class="flex flex-row justify-between mb-1">
            <div class="w-36 mr-1"><p class="text-xs text-left">{{office}}</p></div>
          </div>
        </div>
      </div>
     </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: [
    'userAssociatedText', 'popUpUser'
  ],
  data () {
    return {
      showPopup: false,
      timer: '',
      isInInfo: false
    }
  },
  computed: {
    offices () {
      return this.userAssociatedText
        .split(',')
        .map(item => item.trim())
        .filter(item => item)
    }
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    hover (check) {
      if (!check) {
        return
      }
      let vm = this
      this.timer = setTimeout(function () {
        vm.showPopover()
      }, 600)
    },

    hoverOut () {
      let vm = this
      clearTimeout(vm.timer)
      this.timer = setTimeout(function () {
        if (!vm.isInInfo) {
          vm.closePopover()
        }
      }, 200)
    },

    hoverInfo () {
      this.isInInfo = true
    },

    hoverOutInfo () {
      this.isInInfo = false
      this.hoverOut()
    },

    showPopover () {
      this.showPopup = true
    },

    closePopover () {
      this.showPopup = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .inline{
    display: inline-block;
    position: relative;
  }
  .user-popover{
    position: absolute;
    left: 100%;
    bottom: -120%;
    background: #707070;
    border: 1px solid #fff;
    color: #fff;
    z-index:999;
  }

  .scrollbar {
    scrollbar-width: 1px; /* for Firefox */
    overflow-x: scroll !important;
  }

  .user-popover:before {
  content:"";
    position: absolute;
    height: 0px;
    width: 0px;
    bottom: 10px;
    left: -29px; /* 1px buffer for zooming problems while rendering*/
    border-width: 15px;
    border-color: transparent #707070 transparent transparent;
    border-style: solid;
  }

</style>
